import React from "react";
import { Package, Truck, User, Tag, Shield, Tool, Volume2, Layers } from "react-feather";

// One look per LPO purpose (2026-09-12) so a list can be read by colour and
// icon before a word of it: what was this purchase FOR. Values are the
// App_StockLpo.PurposeType tokens (see LpoForm's PURPOSE_TYPES).
export const LPO_PURPOSE = {
  CONSTRUCTION: { label: "Construction", icon: Layers, color: "#5D4037", bg: "#EFEBE9" },
  CUSTOMER_SPECIFIC: { label: "Customer", icon: User, color: "#6E1423", bg: "#F8E9EC" },
  GENERAL_REPLENISHMENT: { label: "General", icon: Package, color: "#1565C0", bg: "#E3F2FD" },
  GUARDING: { label: "Guarding", icon: Shield, color: "#2E7D32", bg: "#E8F5E9" },
  MAINTENANCE: { label: "Maintenance", icon: Tool, color: "#00695C", bg: "#E0F2F1" },
  MARKETING: { label: "Marketing", icon: Volume2, color: "#7B1FA2", bg: "#F3E5F5" },
  VEHICLE_MAINTENANCE: { label: "Vehicle", icon: Truck, color: "#E65100", bg: "#FFF3E0" },
  // Legacy only (Batch196 stopped offering it) - existing LPOs still carry it.
  OTHER: { label: "Other", icon: Tag, color: "#546E7A", bg: "#ECEFF1" },
};

const purposeOf = (purposeType) => LPO_PURPOSE[purposeType] || LPO_PURPOSE.OTHER;

/** Small round icon chip - the leading mark on a list row. */
export const LpoPurposeIcon = ({ purposeType, size = 28 }) => {
  const p = purposeOf(purposeType);
  const Icon = p.icon;
  return (
    <span
      className="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
      style={{ width: size, height: size, background: p.bg, color: p.color, border: `1px solid ${p.color}40` }}
      title={purposeType?.replaceAll("_", " ")}
    >
      <Icon size={Math.round(size * 0.5)} />
    </span>
  );
};

/** Coloured pill with icon + short label - for the Purpose column. */
export const LpoPurposePill = ({ purposeType }) => {
  const p = purposeOf(purposeType);
  const Icon = p.icon;
  return (
    <span
      className="badge d-inline-flex align-items-center gap-1"
      style={{ background: p.bg, color: p.color, border: `1px solid ${p.color}55`, fontWeight: 600 }}
    >
      <Icon size={12} /> {p.label}
    </span>
  );
};
